module.exports = __webpack_public_path__ + "assets/img/img-2.d315e2ce.png";